import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import styles from './YesNoIndicator.module.scss';

interface YesNoIndicatorProps {
  value: boolean | string;
  showIcon?: boolean;
}

const YesNoIndicator: FC<YesNoIndicatorProps> = ({
  value,
  showIcon = true,
}) => {
  const { t } = useTranslation('actions');
  const isTrue =
    typeof value === 'string' ? value.toLowerCase() === 'true' : value;

  return (
    <div className="flex align-items-center justify-content-center">
      {showIcon && isTrue && (
        <FontAwesomeIcon icon={faCheckCircle} className={styles.checkIcon} />
      )}
      {showIcon && !isTrue && (
        <FontAwesomeIcon icon={faTimesCircle} className={styles.crossIcon} />
      )}
      <span>{isTrue ? t('yes') : t('no')}</span>
    </div>
  );
};

export default YesNoIndicator;
